import { render, staticRenderFns } from "./MannerFeedbackComponent.vue?vue&type=template&id=5bb51038&scoped=true"
import script from "./MannerFeedbackComponent.vue?vue&type=script&lang=js"
export * from "./MannerFeedbackComponent.vue?vue&type=script&lang=js"
import style0 from "./MannerFeedbackComponent.vue?vue&type=style&index=0&id=5bb51038&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb51038",
  null
  
)

export default component.exports